import React from 'react';
import PropTypes from 'prop-types';
import Button from 'shared/button';

export default function CaCopy({ readOnly, text, onCopy, onTextChange }) {
  function handleTextChange(e) {
    if (readOnly) return;

    onTextChange(e.target.value);
  }

  return (
    <React.Fragment>
      <div className={`text ${readOnly ? 'property-default-ca' : ''}`}>
        <textarea className="form-control" readOnly={readOnly} value={text} onChange={handleTextChange}/>
      </div>
      {!readOnly && (
        <Button.Secondary className="justify-content-center" plain type="text" onClick={onCopy}>
          Copy default CA
        </Button.Secondary>
      )}
    </React.Fragment>
  );
}

CaCopy.propTypes = {
  readOnly: PropTypes.bool.isRequired,
  text: PropTypes.string,
  onCopy: PropTypes.func,
  onTextChange: PropTypes.func
};
